import type { HTMLAttributes } from 'react';
import { cn } from '@/utils/cn';

export type PageSectionTitleProps = HTMLAttributes<HTMLHeadingElement>;

export const PageSectionTitle = ({
  children,
  className,
  ...props
}: PageSectionTitleProps) => {
  return (
    <h2 className={cn('font-bold text-2xl text-white', className)} {...props}>
      {children}
    </h2>
  );
};
